export const radii = {
  none: "0",
  sm: "2px",
  base: "4px",
  round: "50%",
  roundedInput: "38px",
  ovalImg: "168px",
}
